import { Outlet } from 'react-router'
import { SharedSnackbar } from '../components/SharedSnackbar'

export default function AppLayout() {
  return (
    <>
      <SharedSnackbar />
      <Outlet />
    </>
  )
}
